import { render, staticRenderFns } from "./video_up.vue?vue&type=template&id=3389d4a4"
import script from "./video_up.vue?vue&type=script&lang=js"
export * from "./video_up.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3389d4a4')) {
      api.createRecord('3389d4a4', component.options)
    } else {
      api.reload('3389d4a4', component.options)
    }
    module.hot.accept("./video_up.vue?vue&type=template&id=3389d4a4", function () {
      api.rerender('3389d4a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/iot/video/video_up.vue"
export default component.exports